import { getNavigatorOnlineSnapshot } from '@/hooks/desktop/useNavigatorOnline';
import { isConfirmedDesktopOfflineNetworkMode } from '@/utils/http/desktopOfflineNetwork';

export function readAutoRetryEnv(): { isOnline: boolean } {
  return {
    isOnline: getNavigatorOnlineSnapshot() && !isConfirmedDesktopOfflineNetworkMode(),
  };
}
